/**
 * 展立键盘 Tab：无修饰键单键（demo type=0x80, code1=0, code2=HID）
 */
import { ZHANLI_T_COMBO, zhanliEventCodeToKeyByte } from "./comboKey";

export type ZhanliKeyboardKeyGroup =
  | "letter"
  | "number"
  | "function"
  | "control"
  | "arrow";

type ZhanliKeyboardKeyDef = {
  eventCode: string;
  label: string;
  group: ZhanliKeyboardKeyGroup;
};

function letterKeys(): ZhanliKeyboardKeyDef[] {
  return "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("").map((ch) => ({
    eventCode: `Key${ch}`,
    label: ch,
    group: "letter" as const,
  }));
}

function numberKeys(): ZhanliKeyboardKeyDef[] {
  return "0123456789".split("").map((ch) => ({
    eventCode: `Digit${ch}`,
    label: ch,
    group: "number" as const,
  }));
}

function functionKeys(): ZhanliKeyboardKeyDef[] {
  return Array.from({ length: 12 }, (_, i) => {
    const n = i + 1;
    return {
      eventCode: `F${n}`,
      label: `F${n}`,
      group: "function" as const,
    };
  });
}

/** 与 mouse-management jiangmeng/KeyboardTab 控制键一致（不含 LCtrl 等修饰键） */
function controlKeys(): ZhanliKeyboardKeyDef[] {
  return [
    { eventCode: "Tab", label: "Tab", group: "control" },
    { eventCode: "Enter", label: "Enter", group: "control" },
    { eventCode: "Space", label: "Space", group: "control" },
    { eventCode: "Backspace", label: "Backspace", group: "control" },
    { eventCode: "Delete", label: "Delete", group: "control" },
    { eventCode: "Escape", label: "Esc", group: "control" },
    { eventCode: "PrintScreen", label: "截图", group: "control" },
    { eventCode: "Home", label: "Home", group: "control" },
    { eventCode: "End", label: "End", group: "control" },
    { eventCode: "PageUp", label: "PageUp", group: "control" },
    { eventCode: "PageDown", label: "PageDown", group: "control" },
    { eventCode: "Insert", label: "Insert", group: "control" },
    { eventCode: "CapsLock", label: "CapsLock", group: "control" },
  ];
}

function arrowKeys(): ZhanliKeyboardKeyDef[] {
  return [
    { eventCode: "ArrowUp", label: "↑", group: "arrow" },
    { eventCode: "ArrowDown", label: "↓", group: "arrow" },
    { eventCode: "ArrowLeft", label: "←", group: "arrow" },
    { eventCode: "ArrowRight", label: "→", group: "arrow" },
  ];
}

export const ZHANLI_KEYBOARD_TAB_KEYS: ZhanliKeyboardKeyDef[] = [
  ...letterKeys(),
  ...numberKeys(),
  ...functionKeys(),
  ...controlKeys(),
  ...arrowKeys(),
];

export function zhanliKeyboardHidFromEventCode(
  eventCode: string
): number | undefined {
  return zhanliEventCodeToKeyByte(eventCode);
}

export function zhanliKeyboardKeyToStoreValue(
  hid: number
): (string | number)[] {
  return ["zhanli", ZHANLI_T_COMBO, 0, hid & 0xff, 0];
}
